var _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXxLargeProd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "extraExtraLargeProd",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2434",
    "data-name": "Path 2434",
    d: "M6,0H68a6,6,0,0,1,6,6V69a6,6,0,0,1-6,6H6a6,6,0,0,1-6-6V6A6,6,0,0,1,6,0Z",
    fill: "rgba(0,0,0,0.8)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_2X",
    "data-name": "2X",
    transform: "translate(15.5 50.5)",
    fill: "#fff",
    fontSize: 35,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2X"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXxLargeProd);
export default __webpack_public_path__ + "static/media/XXLargeProd.55b8c7ab63dc07e1d957515a207ff9e5.svg";
export { ForwardRef as ReactComponent };